import "./NetworkCard.css";
import { FaUser, FaEye, FaUserPlus, FaCheck } from "react-icons/fa";
import { post, deleteRequest } from "../http/api";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getMediaUrl } from "../http/media";
import { getProfileDisplayName } from "../utils/profileDisplayName";




export default function NetworkCard({ profile }) {

  const navigate = useNavigate();
  const [toast, setToast] = useState("");
  const [isFollowing, setIsFollowing] =
    useState(
      Boolean(
        profile.is_following
      )
    );

  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();
  const displayName = getProfileDisplayName(profile);

  const ROLE_LABELS = {
    lawyer: t("networkCard.lawyer"),
    athlete: t("networkCard.athlete"),
    club: t("networkCard.club"),
    brand: t("networkCard.brand"),
    staff: t("networkCard.staff"),
    fan: t("networkCard.fan"),
    media: t("networkCard.media")
  };

  const handleFollow =
    async () => {

      try {

        setLoading(true);

        if (isFollowing) {

          await deleteRequest(
            `follows/${profile.id}`
          );

          setIsFollowing(
            false
          );

          setToast(
            t(
              "networkCard.unfollowedToast",
              {
                name: displayName
              }
            )
          );

        }
        else {

          await post(
            `follows/${profile.id}`
          );

          setIsFollowing(
            true
          );

          setToast(
            t(
              "networkCard.followedToast",
              {
                name: displayName
              }
            )
          );

        }

        setTimeout(() => {

          setToast("");

        }, 2500);

      }
      catch (err) {

        console.log(err);

      }
      finally {

        setLoading(false);

      }

    };


  const handleViewProfile = () => {

    navigate(
      `/user/${profile.username}`
    );

  };



  return (

    <>

      <div className="network-card">

        <div className="network-avatar">

          {profile.image
            ? (

              <img
                src={getMediaUrl(profile.image)}
                // src={`${UPLOADS_URL}/${profile.image}`}
                alt={displayName}
              />

            )

            : (

              <FaUser />

            )}

        </div>


        <h4>
          {displayName}
        </h4>

        <span
          className={`role-badge ${profile.role}`}
        >

          {
            ROLE_LABELS[
            profile.role?.toLowerCase()
            ] || profile.role
          }

        </span>


        <div className="network-actions">

          <button
            className="btn-outline"
            onClick={handleViewProfile}
          >
            <FaEye />
            {t("networkCard.viewProfile")}
          </button>


          <button

            className={
              isFollowing
                ?
                "btn-following"
                :
                "btn-primary"
            }

            onClick={
              handleFollow
            }

            disabled={
              loading
            }

          >

            {

              isFollowing
                ?
                <>
                  <FaCheck />
                  {t("networkCard.following")}
                </>
                :
                <>
                  <FaUserPlus />
                  {t("networkCard.follow")}
                </>
            }

          </button>

        </div>

      </div>


      {toast && (
        <div className="share-success-toast">
          <div
            className="share-success-icon"
          >
            ✓
          </div>
          <div>
            <p>
              {toast}
            </p>
          </div>
        </div>
      )}
    </>

  );

}
